var map = {
	"./bg/strings.json": 1929,
	"./cs/strings.json": 1930,
	"./da/strings.json": 1931,
	"./de/strings.json": 1932,
	"./el/strings.json": 1933,
	"./es-ES/strings.json": 1934,
	"./es-LA/strings.json": 1935,
	"./et/strings.json": 1936,
	"./fi/strings.json": 1937,
	"./fr-CA/strings.json": 1938,
	"./fr/strings.json": 1939,
	"./it/strings.json": 1940,
	"./lt/strings.json": 1941,
	"./lv/strings.json": 1942,
	"./nl/strings.json": 1943,
	"./no/strings.json": 1944,
	"./pl/strings.json": 1945,
	"./pseudo/strings.json": 1946,
	"./pt/strings.json": 1947,
	"./ro/strings.json": 1948,
	"./sk/strings.json": 1949,
	"./sl/strings.json": 1950,
	"./sv/strings.json": 1951,
	"./zh-CN/strings.json": 1952,
	"./zh-TW/strings.json": 1953
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1928;